export const _en = {
    uid: {
        label: "Uid"
    },
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    fluxType: {
        label: "Type"
    },
    lastExecutionDate: {
        label: "Last execution date"
    },
    lastRefFluxExecutionStatusId: {
        label: "Last execution status"
    }
};

export const _fr = {
    uid: {
        label: "UID"
    },
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    fluxType: {
        label: "Type"
    },
    lastExecutionDate: {
        label: "Date et heure de dernière exécution"
    },
    lastRefFluxExecutionStatusId: {
        label: "Statut de dernière exécution"
    }
};